<template>
  <div>
    <div class="box">
      <div class='serve_container'>

        <div class="serve_con">
          <div class="serve_iterm">
            <div class="serve_iterm ">
              <div class=" font_w"> 1.司机抽成比例</div>
              <div class="p">我司承诺，中成智运在司机端无抽成。</div>
            </div>

            <div class="serve_iterm ">
              <div class=" font_w"> 2.货主抽成比例</div>
              <div>
                <ul class="ulstyle">
                  <li><span>月度GMV</span><span>比例</span> </li>
                  <li><span> GMV &lt; 100万</span><span>5.5%</span> </li>
                  <li><span>100万 &lt; GMV &lt; 200万</span><span>5.4%</span> </li>
                  <li><span>GMV &gt; 200万</span><span>5.3%</span> </li>
                </ul>
              </div>
            </div>
            <div class="serve_iterm ">

              <div class="p">备注：大客户可以采取一事一议的方式确定比例。</div>
              <div class="p">计算公式：客户月抽成金额=月结算金额/（1-比例）-月结算金额</div>

            </div>
            <div class="serve_iterm " style="    text-align: right;">

              <div class="p">中成智运（辽宁）网络科技有限公司</div>
              <div class="p">2022年8月15日</div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  onLoad () { },
  methods: {}
};
</script>

<style scoped>
.serve_container {
  background-color: #fff;
  overflow: hidden;
  overflow-y: auto;
  height: 60vh;
}

.serve_title {
  p-align: center;
  padding: 30upx 0;
  color: #323333;
  font-size: 36upx;
  font-weight: bold;
}

.font_w {
  font-weight: bold;
  color: #333;
  font-size: 18px;
  line-height: 50px;
}

.serve_con {
  padding: 0 40upx;
}

.p_ind {
  p-indent: 2em;
}

.mar_bt {
  margin-bottom: 30upx;
}

.serve_iterm {
  margin-bottom: 40upx;
}

.serve_iterm .p {
  font-size: 18px;
  line-height: 34px;
}
.ulstyle {
  width: 920px;
  border: 1px solid #ccc;
}
.ulstyle li {
  line-height: 50px;
  text-align: center;
}
.ulstyle li span {
  display: inline-block;
  border: 1px solid #ccc;
  width: 50%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/auth/service.vue